import * as yup from 'yup';

export const apiResponseSchema = yup.object({
  success: yup.boolean().required('Success Stutus is required'),
  errorMessage: yup.string().optional().nullable()
});

export type ApiResponseType = yup.InferType<typeof apiResponseSchema>;
